var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiGrinningFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1027_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint0_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint1_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint2_radial_1027_718)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint3_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint4_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint5_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 30.4978C25.3333 30.4978 29.9978 24.2303 29.9978 16.4989C29.9978 8.76751 25.3333 2.5 15.9989 2.5C6.66443 2.5 2 8.76751 2 16.4989C2 24.2303 6.66443 30.4978 15.9989 30.4978Z",
    fill: "url(#paint6_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8,
    cy: 13,
    rx: 5,
    ry: 4.5,
    fill: "url(#paint7_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12.5,
    r: 4,
    fill: "url(#paint8_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11C15 12.4239 14.3387 13.6933 13.3064 14.5179C12.5033 14.2485 11.4768 14 10.5 14C9.5232 14 8.49671 14.2485 7.69357 14.5179C6.66132 13.6933 6 12.4239 6 11C6 8.51472 8.01472 6.5 10.5 6.5C12.9853 6.5 15 8.51472 15 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 11C26 12.4239 25.3387 13.6933 24.3064 14.5179C23.5033 14.2485 22.4768 14 21.5 14C20.5232 14 19.4967 14.2485 18.6936 14.5179C17.6613 13.6933 17 12.4239 17 11C17 8.51472 19.0147 6.5 21.5 6.5C23.9853 6.5 26 8.51472 26 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5C12.6569 13.5 14 12.1569 14 10.5C14 8.84315 12.6569 7.5 11 7.5C9.34315 7.5 8 8.84315 8 10.5C8 12.1569 9.34315 13.5 11 13.5Z",
    fill: "url(#paint9_linear_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5C22.6569 13.5 24 12.1569 24 10.5C24 8.84315 22.6569 7.5 21 7.5C19.3431 7.5 18 8.84315 18 10.5C18 12.1569 19.3431 13.5 21 13.5Z",
    fill: "url(#paint10_linear_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25.5C7 25.5 7 16.5 7 16.5H25C25 16.5 25 25.5 16 25.5Z",
    fill: "url(#paint11_radial_1027_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 17V16.5H24V17C24 17.5523 23.5523 18 23 18H9C8.44772 18 8 17.5523 8 17Z",
    fill: "url(#paint12_linear_1027_718)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 9.5) rotate(131.878) scale(38.9487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474827,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 13) rotate(101.31) scale(17.8466 22.8581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.787821,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972509,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18 14.5) rotate(135) scale(41.0122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.314853,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 17.5) rotate(77.692) scale(28.1469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.507903,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 17) rotate(55.7131) scale(13.3135 9.65032)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5 18.5) rotate(9.86581) scale(11.6726)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.900412,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5 15.5) rotate(43.9708) scale(59.0529)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185425,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8889 9.5) rotate(138.013) scale(9.26805 4.77033)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1111 9.38889) rotate(135) scale(7.2282 4.08044)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#392108"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C87928",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1027_718",
    x1: 22.1538,
    y1: 7.5,
    x2: 21,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1027_718",
    x1: 22.1538,
    y1: 7.5,
    x2: 21,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#553B3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D2432"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1027_718",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 27.5) rotate(-90) scale(11 22)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70A8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89029C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1027_718",
    x1: 16,
    y1: 16.5,
    x2: 16,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECCDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1027_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiGrinningFace);
export default __webpack_public_path__ + "static/media/emoji-grinning-face.fb344940538a5589fa739141375cb201.svg";
export { ForwardRef as ReactComponent };